@if (!!label()) {
  <label [for]="id()" class="form-label" [style]="labelStyles()"
    >{{ label() }}
  </label>
}

<div
  class="mb-2"
  [class]="{
    'form-field': !inputTypeGroup(),
    'input-group': inputTypeGroup(),
  }"
>
  @if (inputTypeGroup()) {
    <span class="input-group-text">{{ labelGroup() }}</span>
  }

  <input
    #input
    [id]="id()"
    [type]="type()"
    [attr.inputmode]="inputMode()"
    [attr.pattern]="pattern() || null"
    [b2cTrimInput]="trim()"
    data-cy="input"
    [(ngModel)]="value"
    class="form-control"
    [disabled]="disabled"
    [maxLength]="maxLength()"
    [attr.aria-label]="ariaLabel() || null"
    [attr.aria-describedby]="id() + '-errors'"
    [autocomplete]="autoComplete() ? autoComplete() : 'off'"
    [required]="required()"
    [attr.aria-invalid]="
      control && control.touched && control.dirty && control.invalid
    "
    [minLength]="minLength()"
    (input)="onInput($event)"
    [placeholder]="placeholder() ? placeholder() : label()"
    [class.is-invalid]="
      control && control.touched && control.dirty && control.invalid
    "
  />

  @let tooltipConfig = tooltip();
  @if (tooltipConfig && tooltipConfig.visible) {
    <b2c-tooltip
      position="above"
      class="tooltip-info"
      [icon]="tooltipConfig.icon"
      [content]="tooltipConfig.content"
      [alt]="tooltipConfig.alternativeText"
    />
  }
</div>

<b2c-form-field-errors
  [id]="id() + '-errors'"
  [control]="control"
  [errorStyles]="errorStyles()"
  [errorMessages]="errorMessages()"
  [serverErrorMessage]="serverErrorMessage()"
/>
